import { DEBUG_MODE } from "@angular/fire/compat/analytics";

import type { EnvironmentParams } from "./EnvironmentParams";
import { analyticsProvidersCommon, firebaseConfig } from "./firebaseConfig";
import { version } from "./build-version";

export const environment: EnvironmentParams = {
  version,
  production: true,
  firebaseConfig,
  showDevUi: true,
  firebaseProviders: [
    ...analyticsProvidersCommon,
    {
      provide: DEBUG_MODE,
      useValue: true,
    },
  ],
};
